export default "__VITE_ASSET__I46uDfyy__"